export const MODULE_KEYS = ['hutbook', 'meetings', 'blog', 'storage', 'info'] as const;
export type ModuleKey = (typeof MODULE_KEYS)[number];
export type ModuleSettings = Record<ModuleKey, boolean>;

export interface ModuleLoadState {
    isLoading: boolean;
    isError: boolean;
}

/**
 * Fail-closed: liefert nur dann `true`, wenn die Moduleinstellungen geladen sind
 * UND der Wert `true` ist. Während des Ladens, bei Fehlern oder unbekannten
 * Werten wird `false` zurückgegeben, damit keine deaktivierten/gecachten
 * Inhalte kurz sichtbar werden.
 */
export function moduleEnabled(
    modules: Partial<ModuleSettings> | undefined,
    key: ModuleKey,
    state: ModuleLoadState,
): boolean {
    if (state.isLoading || state.isError || !modules) {
        return false;
    }
    return modules[key] === true;
}

export type ModuleGateDecision = 'loading' | 'allow' | 'redirect';

/**
 * Entscheidung für den Route-Guard (ohne Router-Abhängigkeit, damit testbar):
 * - `loading`: Einstellungen laden noch → Ladezustand zeigen (kein Redirect).
 * - `allow`: Modul aktiv → Seite rendern.
 * - `redirect`: Modul deaktiviert ODER Ladefehler → fail-closed umleiten.
 */
export function moduleGateDecision(
    modules: Partial<ModuleSettings> | undefined,
    key: ModuleKey,
    state: ModuleLoadState,
): ModuleGateDecision {
    if (state.isLoading) {
        return 'loading';
    }
    return moduleEnabled(modules, key, state) ? 'allow' : 'redirect';
}
